"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNetworkError = exports.default = void 0;
var isNetworkError = error => {
  var _error$message, _error$message$toLowe;
  // e.code ECONNABORTED in case of timeout =>ios
  // e.message Network Error => android
  return (error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED' || (error === null || error === void 0 || (_error$message = error.message) === null || _error$message === void 0 || (_error$message$toLowe = _error$message.toLowerCase) === null || _error$message$toLowe === void 0 ? void 0 : _error$message$toLowe.call(_error$message)) === 'network error';
};
exports.isNetworkError = isNetworkError;
var _default = exports.default = {
  isNetworkError
};